export const isAppleSupportVersion = () => {
  let { userAgent } = window.navigator;
  let start = userAgent.indexOf('OS ');
  if (start === -1) return false;
  let result = userAgent
    .substr(start + 3, 6)
    .replace(/_/g, '.')
    .split('.');

  // 10.1 以前禁止 apple pay
  if (result[0] < 10 || (result[0] === 10 && result[1] === 0)) {
    return false;
  }
  return true;
};

export const isLineInAppWebView = () => {
  let { userAgent } = window.navigator;
  return userAgent.match('Line/[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}');
};
